import { Grid, Typography } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";
import { assetItems } from "../../steps/objects/assetItems";
import { otherLiabilityItems } from "../../steps/objects/otherLiabilityItems";

const grandSeperator = val => {
  if(!val) {
		return "0"
	}
  
  val = val
    .toString()
    .replace(/,/g, "")
    .replace(/ /g, "");
  let parsed = parseInt(val);

  if (!isNaN(parsed)) {
    return parsed.toLocaleString().replace(/,/g, " ");
  } else {
    return val;
  }
};

const BalanceSheet = props => {
  const balance_sheet = props.state.result.balanceSheet;
  
  return (
    <React.Fragment>
      <Grid container className="fnaGridHeading">
        <GridItem xs={6} sm={6} md={6}>
          <Typography variant="subheading">
            <strong>Assets</strong>
          </Typography>
        </GridItem>

        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Client</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Spouse</strong>
          </Typography>
        </GridItem>
      </Grid>
      <Grid direction="column" className="fnaGridBody">
        {balance_sheet.assets.map((assetType, i) => {
          let mappedAsset = assetType.description;
          const assetName = mappedAsset
           
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={i % 2 === 0 ? "" : "disabledRow"}
            >
              <Grid container className="fnaGridBodyRow">
                <GridItem xs={6} sm={6} md={6}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {assetName}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(assetType.ownershipClient.toString())}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(assetType.ownershipSpouse)}
                  </Typography>
                </GridItem>
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={12} sm={12} md={12} style={{}}>
          <Grid container className="fnaGridBodyRow">
            <GridItem xs={6} sm={6} md={6}>
              <Typography style={{ paddingTop: "20px" }}>
                <strong>Total</strong>
              </Typography>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R {grandSeperator(balance_sheet.netAssetsClient)}</b>
              </Typography>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <Typography style={{ paddingTop: "20px" }}>
               <b> R {grandSeperator(balance_sheet.netAssetsSpouse)}</b>
              </Typography>
            </GridItem>
          </Grid>
        </Grid>
      </Grid>


 {/* Policies */}

 <Grid container className="fnaGridHeading">
        <GridItem xs={6} sm={6} md={6}>
          <Typography variant="subheading">
            <strong>Cash values of policies</strong>
          </Typography>
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Client</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Spouse</strong>
          </Typography>
        </GridItem>
      </Grid>
      
      <Grid direction="column" className="fnaGridBody">
        {balance_sheet.policies.map((policy, i) => {
          let mappedLiability = {};
          
          const policyName = policy.description;
            

          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={i % 2 === 0 ? "" : "disabledRow"}
            >
              <Grid container className="fnaGridBodyRow">
                <GridItem xs={6} sm={6} md={6}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {policyName}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(policy.amountClient)}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(policy.amountSpouse)}
                  </Typography>
                </GridItem>
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={12} sm={12} md={12} style={{}}>
          <Grid container className="fnaGridBodyRow">
            <GridItem xs={6} sm={6} md={6}>
              <Typography style={{ paddingTop: "20px" }}>
                <strong>Total</strong>
              </Typography>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R{" "}
                {grandSeperator(
                  balance_sheet.netPoliciesClient
                )}</b>
              </Typography>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R{" "}
                {grandSeperator(
                  balance_sheet.netPoliciesSpouse
                )}</b>
              </Typography>
            </GridItem>
          </Grid>
        </Grid>
      </Grid>




      {/* Liabilities */}

      <Grid container className="fnaGridHeading">
        <GridItem xs={6} sm={6} md={6}>
          <Typography variant="subheading">
            <strong>Liabilities</strong>
          </Typography>
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Client</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Spouse</strong>
          </Typography>
        </GridItem>
      </Grid>
      
      <Grid direction="column" className="fnaGridBody">
        {balance_sheet.liabilities.map((liabilityType, i) => {
          let mappedLiability = {};
          
          const liabilityName = liabilityType.description;
            

          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={i % 2 === 0 ? "" : "disabledRow"}
            >
              <Grid container className="fnaGridBodyRow">
                <GridItem xs={6} sm={6} md={6}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {liabilityName}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(liabilityType.amountClient)}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(liabilityType.amountSpouse)}
                  </Typography>
                </GridItem>
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={12} sm={12} md={12} style={{}}>
          <Grid container className="fnaGridBodyRow">
            <GridItem xs={6} sm={6} md={6}>
              <Typography style={{ paddingTop: "20px" }}>
                <strong>Total</strong>
              </Typography>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R{" "}
                {grandSeperator(
                  balance_sheet.netLiabilitiesClient
                )}</b>
              </Typography>
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <Typography style={{ paddingTop: "20px" }}>
               <b> R{" "}
                {grandSeperator(
                  balance_sheet.netLiabilitiesSpouse
                )}</b>
              </Typography>
            </GridItem>
          </Grid>
        </Grid>
      </Grid>

      <Grid container style={{ marginTop: "25px" }}>
        <GridItem
          xs={6}
          sm={6}
          md={6}
          style={{ borderRight: "1px solid #e2e2e2" }}
        >
          <Typography variant="subheading">
            <strong>Net Asset Value: </strong>
          </Typography>
        </GridItem>
        <GridItem
          xs={3}
          sm={3}
          md={3}
          style={{ borderRight: "1px solid #e2e2e2" }}
        >
          <Typography variant="caption">Client</Typography><b>R{" "}
          {grandSeperator(balance_sheet.netTotalAssetsClient)}</b>
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="caption">Spouse</Typography><b>R{" "}
          {grandSeperator(balance_sheet.netTotalAssetsSpouse)}</b>
        </GridItem>
      </Grid>

      <Grid container style={{ marginTop: "25px" }}>
        <GridItem
          xs={6}
          sm={6}
          md={6}
          
        >
          <Typography variant="subheading">
            <strong>Policies Payable to Estate: </strong>
          </Typography>
        </GridItem>
        <GridItem
          xs={3}
          sm={3}
          md={3}
         
        >
          R{" "}
          {grandSeperator(props.state.result.executorFees.pToEstate)}
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          
        </GridItem>
      </Grid>
      <Grid container style={{  }}>
        <GridItem
          xs={6}
          sm={6}
          md={6}
          
        >
          <Typography variant="subheading">
            <strong>Percentage applicable: </strong>
          </Typography>
        </GridItem>
        <GridItem
          xs={3}
          sm={3}
          md={3}
        
        >
          
          {(props.state.result.executorFees.percentageApplicable)}%
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          
        </GridItem>
      </Grid>
      <Grid container style={{  }}>
        <GridItem
          xs={6}
          sm={6}
          md={6}
          
        >
          <Typography variant="subheading">
            <strong>VAT: </strong>
          </Typography>
        </GridItem>
        <GridItem
          xs={3}
          sm={3}
          md={3}
          
        >
          
          {grandSeperator(props.state.result.executorFees.vat)}%
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          
        </GridItem>
      </Grid>
      
      
      <Grid container style={{ marginTop: "25px" }}>
        <GridItem
          xs={6}
          sm={6}
          md={6}
          
        >
          <Typography variant="subheading">
            <strong>Executor fees: </strong>
          </Typography>
        </GridItem>
        <GridItem
          xs={3}
          sm={3}
          md={3}
          
        >
          <b>
          R{" "}
          {grandSeperator(props.state.result.executorFees.executorFee)}
          </b>
        </GridItem>
        <GridItem xs={3} sm={3} md={3}>
          
        </GridItem>
      </Grid>
   
    
    </React.Fragment>
  );
};

export default BalanceSheet;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/BalanceSheet.jsx